<div class="household-financial-grid" [formGroup]="formGroup">
  <div class="household-financial-header">
    <h5 class="household-section-title"
        [attr.areia-label]="'household-section-title'"
        id="household-section-title">
        Household Information
    </h5>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper">
      <label for="householdIncome" 
        class="field-label"
        id="householdIncome_label"
        [attr.aria-label]="'householdIncome_label'">
          Disclosed Income
      </label>
      <mat-form-field class="household-fields">
        <input id="householdIncome"
               matInput
               type="number"
               placeholder="Disclosed Income"
               class="user-record-field-input"
               formControlName="householdIncome" />
        @if (formGroup.get('householdIncome')?.invalid && formGroup.get('householdIncome')?.touched) {
        <mat-error>Disclosed Income is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper">
      <label for="verifiedIncome"
        class="field-label"
        id="verifiedIncome_label"
        [attr.aria-label]="'verifiedIncome_label'">
        Verified Income
      </label>
      <input
        id="verifiedIncome"
        matInput
        type="text"
        class="user-record-field-input"
        formControlName="verifiedIncome" />
    </div>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper">
      <label for="householdMemberCount"
        class="field-label"
        id="householdMemberCount_label"
        [attr.aria-label]="'householdMemberCount_label'">
        No. of People in Household
      </label>
      <mat-form-field class="household-fields">
        <input id="householdMemberCount"
               matInput
               type="number"
               placeholder="No. of People in Household"
               class="user-record-field-input"
               formControlName="householdMemberCount" />
        @if (formGroup.get('householdMemberCount')?.invalid && formGroup.get('householdMemberCount')?.touched) {
        <mat-error>No. of People in Household is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper">
      <label for="householdTier" 
        class="field-label"
        id="householdTier_label"
        [attr.aria-label]="'householdTier_label'">
        Household Tier
      </label>
      <input
        id="householdTier"
        matInput
        type="text"
        placeholder="Household Tier"
        class="user-record-field-input"
        formControlName="householdTier" />
    </div>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="householdIncomeVerification" 
        class="field-label"
        id="householdIncomeVerification_label"
        [attr.aria-label]="'householdIncomeVerification_label'">
        Income Verification:
      </label>
      <mat-select id="householdIncomeVerification" formControlName="householdIncomeVerification" placeholder="Select">
        <mat-option [value]="true">Yes</mat-option>
        <mat-option [value]="false">No</mat-option>
      </mat-select>
      @if (householdData?.disclosedInformation === false) {
        <span class="field-hint">
          Household declined to disclose income, so Income Verification does not apply.
        </span>
      }
    </div>
  </div>
  <div class="household-financial-field half-width">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="householdNcResidency"
        class="field-label"
        id="householdNcResidency_label"
        [attr.aria-label]="'householdNcResidency_label'">
        NC Residency:
      </label>
      <mat-select id="householdNcResidency" formControlName="householdNcResidency" placeholder="Select">
        <mat-option value="not-evaluated">Not Evaluated</mat-option>
        <mat-option [value]="true">Yes</mat-option>
        <mat-option [value]="false">No</mat-option>
      </mat-select>
    </div>
  </div>
</div>
